export const TOGGLE_SCOPING_METHOD = 'TOGGLE_SCOPING_METHOD';
export const CATEGORIES = 'CATEGORIES';
export const TEMPLATES = 'TEMPLATES';
export const PAGEPILE = 'PAGEPILE';
export const PETSCAN = 'PETSCAN';
export const UPDATE_CATEGORY_DEPTH = 'UPDATE_CATEGORY_DEPTH';
export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
export const UPDATE_TEMPLATES = 'UPDATE_TEMPLATES';
export const UPDATE_PETSCAN_IDS = 'UPDATE_PETSCAN_IDS';
export const UPDATE_PAGEPILE_IDS = 'UPDATE_PAGEPILE_IDS';
export const RESET_SCOPING_METHODS = 'RESET_SCOPING_METHODS';
